import { render, staticRenderFns } from "./structured.vue?vue&type=template&id=41704e7c"
import script from "./structured.vue?vue&type=script&lang=js"
export * from "./structured.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports